<template>
  <div>
    <div class="zrrlist">
      <!-- 耿彪增加 -->
      <div class="tit">
        <p>水位预警信息</p>
        <ul>
          <li v-for="(item,i) in region" :key="i" :class="regionactivelen==i?'regionactive':''" @click="regionClick(item,i)">{{item.name}}</li>
        </ul>
        <!-- <cityselect v-on:citySelected="citySelected"></cityselect> -->
      </div>
      <ul class="list listb">
        <li>
          <div>
            <p class="titnames">地市名</p>
          </div>
          <div>
            <p class="titnames">坝名</p>
          </div>
          <div>
            <p class="titnames1">预警等级</p>
          </div>
        </li>
      </ul>
      <ul class="list">
        <li v-if="swbjlist.length===0">
            <div style=" color:#FFFFFF;margin-top:50px;margin-left:120px;">暂无预警信息</div>
        </li>
        <li v-else v-for="(item,i) in swbjlist" :key="i" :class="swbjlist.length-1==i?'ddd':''">
          <div>
            <p class="titnames">{{item.city}}</p>
          </div>
          <div>
            <p class="titnames">{{item.ydbName}}</p>
          </div>
          <div>
            <p class="titnames1" v-if="item.level!=null" :style="item.level > 2 ? 'color:#ff6464' : 'color:lime'">{{item.level}}级</p>
            <p class="titnames1" v-if="item.level==null" :style="item.level > 2 ? 'color:#ff6464' : 'color:lime'">无</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="zrrlist">
      <div class="tit">
        <p>应急物资落实情况</p>
        <cityselect v-on:citySelected="citySelected1"></cityselect>
      </div>
      <ul class="list listb">
        <li>
          <div>
            <p class="titnames">地市名称</p>
          </div>
          <div>
            <p class="titnames">淤地坝数量</p>
          </div>
          <div>
            <p class="titnames1">落实率</p>
          </div>
        </li>
      </ul>
      <ul class="list">
        <li v-for="(item,i) in practicablelist" :key="i" :class="practicablelist.length-1==i?'ddd':''">
          <div>
            <p class="titnames">{{item.city}}</p>
          </div>
          <div>
            <p class="titnames">{{item.sum}}</p>
          </div>
          <div>
            <p class="titnames1" :style="item.rate < 60 ? 'color:#ff6464' : 'color:lime'">{{item.rate}}%</p>
          </div>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
  import {
    swbjxx,
    wznrOrlsqk
  } from "@/api/api.js";
  import cityselect from "../../components/cityselect/cityselect.vue";
  export default {
    props: ["Nrssx"],
    data() {
      return {
        region: [{
            name: "省",
            id: 0
          },
          {
            name: "市",
            id: 1
          },
          {
            name: "县",
            id: 2
          },
        ],
        regionactivelen: 0,
        swbjlist: [],
        practicablelist: [],
      };
    },
    components: {
      cityselect: cityselect,
    },
    mounted() {
      if (this.$store.state.type == 0) {
        this.region = [{
            name: "省",
            id: 0
          },
          {
            name: "市",
            id: 1
          },
          {
            name: "县",
            id: 2
          },
        ];
      } else if (this.$store.state.type == 1) {
        this.region = [{
            name: "市",
            id: 1
          },
          {
            name: "县",
            id: 2
          },
        ];
      } else {
        this.region = [];
      }
      let params = {
        type: this.$store.state.type
      };
      this.swbjxxFun(params);
      // this.wznrOrlsqkFun(params);
    },
    watch: {},
    methods: {
      regionClick(item, i) {
        this.regionactivelen = i;
        let params = {
          type: item.id
        };
        this.swbjxxFun(params);
      },
      citySelected(val) {
        let params = {
          type: val.id
        };
        this.swbjxxFun(params);
      },
      citySelected1(val) {
        let params = {
          type: val.id
        };
        this.wznrOrlsqkFun(params);
      },
      citySelected2(val) {
        // console.log("selected2---------->", val);
      },
      swbjxxFun(params) {
        this.swbjlist = [];
        swbjxx(params).then((res) => {
          this.swbjlist = res.data;
          // console.log(res.data)
        });
      },
      wznrOrlsqkFun(params) {
        console.log(params)
        this.practicablelist = [];
        wznrOrlsqk(params).then((res) => {
          this.practicablelist = res.data;
        });
      },
    },
  };
</script>

<style scoped>
  .totalPie,
  .zrrlist {
    width: 100%;
    height: 250px;
    /* height: auto; */
    background: url(../../common/images/contentborder.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
    font-size: 16px;
  }

  .zrrlist {
    margin-top: 15px;
    padding-bottom: 15px;
  }

  .tit {
    padding-bottom: 5px;
    border-bottom: 1px solid #098dc7;
  }

  .tit ul {
    margin-top: 5px;
  }

  .list {
    width: 90%;
    margin: 0 auto;

    height: calc(100% - 75px);
    height: -webkit-calc(100% - 75px);
    height: -moz-calc(100% - 75px);
    overflow: auto;
  }

  .list li {
    width: 100%;
    height: 35px;
    border-top: 1px solid #098dc7;
    cursor: pointer;
  }

  .ddd {
    border-bottom: 1px solid #098dc7;
  }

  .list li div:nth-child(1) {
    width: 30%;
    float: left;
    height: 35px;
  }

  .list li div:nth-child(2) {
    width: 40%;
    float: left;
  }

  .list li div:nth-child(3) {
    width: 30%;
    float: left;
  }

  .titnames {
    line-height: 35px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border-right: 1px solid #098dc7;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .titnames1 {
    line-height: 35px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sta1 {
    height: 35px;
    overflow: hidden;
    border-radius: 12px;
    margin: 0 auto;
    text-align: center;
    line-height: 35px;
    color: #fff;
    font-size: 14px;
    padding-right: 15px;
  }

  .listb {
    border-bottom: none;
    height: 36px;
    margin-top: 10px;
  }

  .listb li {
    background: rgba(0, 179, 254, 0.5);
    height: 35px;
  }

  .listb li div p {
    line-height: 30px !important;
    margin-top: 0px;
  }

  .list li:nth-child(even) {
    background: rgba(0, 179, 254, 0.1);
  }

  .qdimg {
    width: 30px;
    height: 30px;
    margin-top: 2px;
    margin-left: 40%;
  }
</style>
